module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Text/Quote#2-8868123e51b585f66450f25a5c2e7533249a1a907447df8e31bdf9aec30496c0.svg";